import { render, staticRenderFns } from "./ShifokorTash.vue?vue&type=template&id=ff5c049c"
import script from "./ShifokorTash.vue?vue&type=script&lang=js"
export * from "./ShifokorTash.vue?vue&type=script&lang=js"
import style0 from "./ShifokorTash.vue?vue&type=style&index=0&id=ff5c049c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports